<div id="error-line-add-friend">
  <div *ngIf="! customMessage; else elseBlock" class="db-error-section">
    <p>{{'ERROR.ACCOUNT_LINE_NOT_CONNECT'|translate}}</p>
  </div>
  <ng-template #elseBlock>
    <div [innerHTML]="(customMessage || '') | safeHtml" class="db-error-section">
      {{ customMessage }}
    </div>
  </ng-template>
</div>
